import { render, staticRenderFns } from "./ConfigLoginList.vue?vue&type=template&id=1578a465"
import script from "./ConfigLoginList.vue?vue&type=script&lang=js"
export * from "./ConfigLoginList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports